<div [innerHTML]='text + (shortened ? "..." : "")'></div>
